import { render } from "./temp_view-kv-customer-vers.vue?vue&type=template&id=ba178280&scoped=true"
import script from "./temp_view-kv-customer-vers.vue?vue&type=script&setup=true&lang=js"
export * from "./temp_view-kv-customer-vers.vue?vue&type=script&setup=true&lang=js"

import "./temp_view-kv-customer-vers.vue?vue&type=style&index=0&id=ba178280&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba178280"],['__file',"src/views/counteragents/temp_view-kv-customer-vers/temp_view-kv-customer-vers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba178280"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba178280', __exports__)) {
    api.reload('ba178280', __exports__)
  }
  
  module.hot.accept("./temp_view-kv-customer-vers.vue?vue&type=template&id=ba178280&scoped=true", () => {
    api.rerender('ba178280', render)
  })

}


export default __exports__